<template>
	<picture :ref="lazyImageLabel" class="picture-element">
		<source type="image/avif" v-bind="{ [isVisible ? 'srcset' : 'data-srcset']: iconUrl('avif') }" />
		<source type="image/webp" v-bind="{ [isVisible ? 'srcset' : 'data-srcset']: iconUrl('webp') }" />

		<img
			class="provider-icon"
			:loading="loading"
			:fetchpriority="loading === 'lazy' ? 'low' : 'auto'"
			width="80"
			height="32"
			:alt="provider.clearName"
			:title="provider.clearName"
			:src="iconUrl('jpeg')"
			@click="$emit('click')"
		/>
	</picture>
</template>

<script setup lang="ts">
import { lazyImageLabel, useLazyImage } from '@/features/ui/composables/useLazyImage';

const props = withDefaults(
	defineProps<{
		provider?: {
			iconWide: string;
			clearName: string;
		};
		loading?: 'lazy' | 'eager';
	}>(),
	{
		provider: () => ({
			iconWide: 'https://static.justwatch.com/static/compile_jw/assets/jw-icon-badge.png',
			clearName: 'JustWatch',
		}),
		loading: 'lazy',
	}
);

const { jwConfig } = useRuntimeConfig().public;

const { _el, isVisible } = useLazyImage(props.loading !== 'eager');

function iconUrl(format: 'avif' | 'webp' | 'jpeg') {
	const prefix = props.provider.iconWide.startsWith('/') ? jwConfig.IMAGESCALER_URL : '';
	return prefix + props.provider.iconWide.replace('{format}', format);
}
</script>

<style scoped lang="scss">
.picture-element {
	display: inline-block;

	.provider-icon {
		border-radius: 8px;
		height: 32px;
		width: 80px;
		aspect-ratio: 80 / 32;
		min-width: 80px;
		min-height: 32px;
	}
}
</style>
